import { useNavigate } from "react-router-dom";
import { useClientTranslations } from "../../lib/i18n/client";
import styles from "./JourneyNotAvailable.module.css";

export function JourneyNotAvailable() {
	const navigate = useNavigate();
	const { t } = useClientTranslations("journeyEmpty");

	return (
		<section
			className={styles.container}
			aria-labelledby="journey-not-available-title"
		>
			<div className={styles.card}>
				<div className={styles.iconShell} aria-hidden="true">
					<svg
						className={styles.icon}
						viewBox="0 0 32 32"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						aria-hidden="true"
						focusable="false"
					>
						<path
							d="M8 18.5C8 12.701 11.582 8 16 8s8 4.701 8 10.5"
							stroke="currentColor"
							strokeWidth="2"
							strokeLinecap="round"
						/>
						<path
							d="M10.5 22.5h11"
							stroke="currentColor"
							strokeWidth="2"
							strokeLinecap="round"
						/>
						<path
							d="M16 12v5l3 2"
							stroke="currentColor"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				</div>
				<div className={styles.copy}>
					<h2 id="journey-not-available-title" className={styles.title}>
						{t("title")}
					</h2>
					<p className={styles.subtitle}>{t("subtitle")}</p>
				</div>
				<button
					className={styles.cta}
					type="button"
					onClick={() => navigate("/profile")}
				>
					{t("cta")}
				</button>
			</div>
		</section>
	);
}
